import { getStoreId } from "$/hooks/use-store-information"
import storeQueries from "$/lib/queries/store-queries"
import { requireStoreModule } from "$/lib/require-store-module"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/widget-customization",
)({
  loader: async ({ context: { queryClient } }) => {
    await requireStoreModule(queryClient, "whiteLabelBookingEnabled")
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(storeQueries.detail(storeId))
    }

    return {
      crumb: "alfred.settings.nav.widgetCustomization.label",
    }
  },
})
